import React from "react";
import { useSiteMetadata } from "../../../hooks/use-site-metadata";

export const SEO = (props) => {
  const {
    title,
    description,
    img = "",
    keywords = "",
    pathname,
    nonindex = false,
    nofollow = false,
    children,
    ...metaProps // Spread any additional meta attributes
  } = props;

  const { title: defaultTitle, description: defaultDescription, siteUrl } = useSiteMetadata();

  let canonical_link = "";
  if (typeof window !== `undefined`){
      canonical_link =  window.location.href; 
  }

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: img,
    keywords,
    url: `${siteUrl}${pathname || ``}`,
  };

  // Generate robots meta content
  const robotsContent = [
    nonindex ? "noindex" : "index",
    nofollow ? "nofollow" : "follow",
    "max-image-preview:large",
    "max-snippet:-1",
    "max-video-preview:-1",
  ].join(", ");

  return (
    <>
      <title>{seo.title}</title>
      <meta name="robots" content={robotsContent} />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={canonical_link} />
      <meta name="twitter:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={canonical_link} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <link rel="canonical" href={canonical_link} />
      {children}
    </>
  );
};
